import { useTheme } from '@mui/material/styles'
import { IconContext } from 'react-icons'
import { useMemo } from 'react'

export interface Props {
  children: React.ReactNode
}

export default function ThemeIcon({ children }: Readonly<Props>) {
  const theme = useTheme()
  const iconStyle = useMemo(
    () => ({ className: 'react-icon', style: { strokeWidth: theme.palette.iconWeight } }),
    [theme.palette.mode]
  )
  return <IconContext.Provider value={iconStyle}>{children}</IconContext.Provider>
}
